module.exports = __webpack_public_path__ + "static/img/png.59eab145.png";